import React, { useContext } from 'react';
import styled from 'styled-components';
import { RegistrationForm, Button, DateButton, Modal } from 'components';
import BG from 'assets/images/header-background.jpg';
import { fullGridContainer, breakpoints } from 'styles';
import { LocalContext } from 'context';
import Logo from 'assets/images/logo.png';
import LogoContrast from 'assets/images/logo-contrast.png';
import CovidCommsAwardImg from 'assets/images/covid-comms-award.png';
import IrishHealthCareImg from 'assets/images/irish-healthcare-award.png';
import { motion } from 'framer-motion';

const Header = (props) => {
  const { mobile, theme } = useContext(LocalContext);

  const slides = [
    {
      date: '5 - 6 November',
      title: 'Virtual Conference',
      captionTitle: 'Expert, Pioneering, Connected',
      caption:
        'The Fighting Blindness Retina 2021 virtual conference brings together top international and Irish researchers and clinicians to showcase the latest updates on therapeutic interventions, eye care practices and scientific discovery.'
    }
  ];

  return (
    <Carousel>
      {slides.map((slide, i) => (
        <Slide
          key={i}
          theme={theme}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 2 }}>
          <Overlay theme={theme} mobile={mobile} />
          <IrishHealthCareAwardBadge>
            <img src={IrishHealthCareImg} alt="Badge" width="100%" height="auto" />
          </IrishHealthCareAwardBadge>
          <CovidCommsAwardBadge>
            <img src={CovidCommsAwardImg} alt="Badge" width="100%" height="auto" />
          </CovidCommsAwardBadge>
          <TextBox>
            <SlideDate theme={theme}>{slide.date}</SlideDate>
            <SlideTitle theme={theme}>{slide.title}</SlideTitle>
            <img
              src={theme.className === 'contrast' ? LogoContrast : Logo}
              alt="logo"
              width="80%"
              height="auto"
              style={{ marginBottom: '1.25rem' }}
            />
            <SlideCaptionTitle theme={theme}>{slide.captionTitle}</SlideCaptionTitle>
            <SlideCaption theme={theme}>{slide.caption}</SlideCaption>
            <HeaderButtons>
              {/* {!props.stream && mobile ? (
                <Modal
                  trigger={<Button width="11rem">Register Here</Button>}
                  modalContent={<RegistrationForm />}
                />
              ) : !props.stream && !mobile ? (
                <Button width="11rem" onClick={props.scrollToRegister}>
                  Register Here
                </Button>
              ) : null} */}
              {/* {props.stream && (
                <DesktopOnly onClick={props.scrollToRegister}>
                  <Button width="11rem">See Livestream</Button>
                </DesktopOnly>
              )} */}
              <DateButton />
            </HeaderButtons>
          </TextBox>
        </Slide>
      ))}
    </Carousel>
  );
};

const Overlay = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  background-image: ${({ theme, mobile }) =>
    theme.className === 'contrast'
      ? 'linear-gradient(to top, rgba(0,0,0,.9) 30%, rgba(0,0,0,.7))'
      : 'none'};
  @media (max-width: 768px) {
    background-image: ${({ theme, mobile }) =>
      theme.className === 'contrast'
        ? 'linear-gradient(to top, rgba(0,0,0) 50%, rgba(0,0,0,.7) 80%)'
        : 'linear-gradient(to top, #b4d1d7 50%, transparent 80%)'};
  }
  @media (max-width: 350px) {
    background-image: ${({ theme, mobile }) =>
      theme.className === 'contrast'
        ? 'linear-gradient(to top, rgba(0,0,0) 60%, rgba(0,0,0,.7) 80%)'
        : 'linear-gradient(to top, #b4d1d7 60%, transparent 80%)'};
  }
`;

const TextBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  grid-column: 1/7;
  position: relative;
  z-index: 2;
  max-width:750px;
  @media (min-width: 768px) {
    grid-column: 1/7;
    padding: 40px;
  }
  @media (min-width: ${breakpoints.lg}) {
    grid-column: 2/8;
  }
`;

const SlideDate = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 2rem;
  :first-child {
    color: ${({ theme }) => theme.fg};
  }

  @media (min-width: ${breakpoints.lg}) {
    font-size: 2.5rem;
    line-height: 3.5rem;
  }
`;

const SlideTitle = styled(SlideDate)`
  margin-bottom: 3rem;
`;

const SlideCaptionTitle = styled.h2`
  font-style: normal;
  font-weight: 700;
  font-size: 2rem;
  line-height: 2.5rem;
  margin-bottom: 1.25rem;
  @media (min-width: ${breakpoints.lg}) {
    font-size: 2.5rem;
    line-height: 3.5rem;
    margin-bottom: 1.5rem;
  }
`;

const SlideCaption = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5rem;
  margin-bottom: 1.25rem;
  color: ${({ theme }) => theme.textColor};
  @media (min-width: ${breakpoints.lg}) {
    font-size: 1.5rem;
    line-height: 2rem;
    margin-bottom: 1.5rem;
  }
`;

const HeaderButtons = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const CovidCommsAwardBadge = styled.div`
  position: absolute;
  top: 5rem;
  left: 1rem;
  z-index: 3;
  width: 180px;
  height: auto;
  img {
    max-width: 100%;
  }
  @media (min-width: 768px){
    top:initial;
    left:initial;
    bottom: 3rem;
    right:3rem;
  }
`;

const IrishHealthCareAwardBadge = styled.div`
  position: absolute;
  top: 10.25rem;
  left: 1rem;
  z-index: 3;
  width: 180px;
  height: auto;
  img {
    max-width: 100%;
  }
  @media (min-width: 768px){
    top:initial;
    left:initial;
    bottom: 3rem;
    width: 193px;
    right: 14.85rem;
  }
`;

const Slide = styled(motion.div)`
  width: 100%;
  height: auto;
  min-height: 100vh;
  ${fullGridContainer}
  display: none;
  align-items: center;
  justify-content: flex-start;
  background-color: white;
  background-size: 200%;
  background-repeat: no-repeat;
  background-position: 100% 0%;
  background-image: url(${BG});
  display: none;
  padding-bottom: 2.5rem;
  padding-top: 250px;
  position: relative;
  color: ${({ theme }) => theme.textColor};
  @media (min-width: ${breakpoints.sm}) and (min-height: ${breakpoints.md}) {
    min-height: 40vh;
    background-size: cover;
  }
  @media (min-width: ${breakpoints.lg}) {
    min-height: 100vh;
    background-position: center right;
    padding-top: 6rem;
    padding-bottom: 4rem;
    background-size: cover;
  }

  &:first-child {
    display: grid;
  }
`;

const Carousel = styled.header`
  height: 100%;
  width: 100vw;
  grid-column: 1/7;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (min-width: ${breakpoints.lg}) {
    height: auto;
    grid-column: 1/13;
  }
`;

export default Header;
